module.exports = __webpack_public_path__ + "95c1b3a2a07e82aad964b1f8ed1ad663.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-13.png
// module id = 1695
// module chunks = 0